function buildPrescriptionText(prescription) {
  const lines = [
    'FITNOVA — PRESCRIPTION',
    `Doctor: ${prescription.doctor_name}`,
    `Patient: ${prescription.patient_name}${prescription.patient_relation ? ` (${prescription.patient_relation})` : ''}`,
    `Visit: ${prescription.visit_date || '—'}`,
    `Issued: ${new Date(prescription.created_at).toLocaleString()}`,
    '',
    'Medicines:',
  ];
  (prescription.medicines || []).forEach((m, i) => {
    lines.push(
      `${i + 1}. ${m.name} — ${m.dose || '-'}, ${m.frequency || '-'}, ${m.days || '-'} days`
    );
  });
  if (prescription.general_advice) {
    lines.push('', 'Advice:', prescription.general_advice);
  }
  return lines.join('\n');
}

function ViewPrescriptionModal({ prescription, onClose }) {
  if (!prescription) return null;

  const signatureUrl = prescription.doctor_signature || null;

  const handlePrint = () => {
    const w = window.open('', '_blank');
    if (!w) return;
    const meds = (prescription.medicines || [])
      .map(
        (m) =>
          `<tr><td>${m.name}</td><td>${m.dose || '—'}</td><td>${m.frequency || '—'}</td><td>${m.days || '—'}</td></tr>`
      )
      .join('');

    const signatureHtml = signatureUrl
      ? `<div style="margin-top:40px;border-top:1px solid #ccc;padding-top:12px;display:flex;flex-direction:column;align-items:flex-end;">
           <img src="${signatureUrl}" alt="Doctor Signature" style="max-width:180px;max-height:70px;object-fit:contain;" />
           <p style="margin:4px 0 0;font-size:12px;color:#555;"> ${prescription.doctor_name}</p>
           <p style="margin:0;font-size:11px;color:#888;">Digital Signature</p>
         </div>`
      : `<div style="margin-top:40px;border-top:1px solid #ccc;padding-top:12px;text-align:right;">
           <p style="font-size:12px;color:#555;"> ${prescription.doctor_name}</p>
         </div>`;

    w.document.write(`
      <html><head><title>Prescription</title></head><body style="font-family:sans-serif;padding:24px">
      <h2>FITNOVA Prescription</h2>
      <p><b>Doctor:</b> ${prescription.doctor_name}</p>
      <p><b>Patient:</b> ${prescription.patient_name}</p>
      <p><b>Date:</b> ${prescription.visit_date || ''}</p>
      <table border="1" cellpadding="8" cellspacing="0" style="border-collapse:collapse;width:100%">
      <tr><th>Medicine</th><th>Dose</th><th>Frequency</th><th>Days</th></tr>${meds}
      </table>
      ${prescription.general_advice ? `<p><b>Advice:</b><br/>${prescription.general_advice.replace(/\n/g, '<br/>')}</p>` : ''}
      ${signatureHtml}
      </body></html>`);
    w.document.close();
    w.print();
  };

  const handleDownload = () => {
    const blob = new Blob([buildPrescriptionText(prescription)], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `prescription-${prescription.appointment_id || prescription.id}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div
      className="modal d-flex align-items-center justify-content-center"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', inset: 0, zIndex: 1050, overflowY: 'auto' }}
    >
      <div className="modal-dialog modal-lg w-100 my-3" style={{ maxWidth: 800 }}>
        <div className="modal-content border-0 shadow-lg rounded-4">
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold">
              <i className="bi bi-file-medical me-2 text-primary" />
              Prescription
            </h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
          </div>
          <div className="modal-body" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
            <div className="mb-3">
              <p className="mb-1">
                <strong>Doctor:</strong> {prescription.doctor_name}
              </p>
              <p className="mb-1">
                <strong>Patient:</strong> {prescription.patient_name}
                {prescription.patient_relation && (
                  <span className="text-muted"> ({prescription.patient_relation})</span>
                )}
              </p>
              {prescription.booked_by_display && (
                <p className="mb-1 text-muted small">Booked by {prescription.booked_by_display}</p>
              )}
              <p className="mb-0 text-muted small">
                Visit: {prescription.visit_date || '—'}
                {prescription.visit_start_time ? ` · ${prescription.visit_start_time}` : ''}
                {' · '}
                Issued: {new Date(prescription.created_at).toLocaleDateString()}
              </p>
            </div>

            <h6 className="fw-bold">Medicines</h6>
            <div className="table-responsive mb-3">
              <table className="table table-sm table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Medicine</th>
                    <th>Dose</th>
                    <th>Frequency</th>
                    <th>Days</th>
                  </tr>
                </thead>
                <tbody>
                  {(prescription.medicines || []).map((m, i) => (
                    <tr key={i}>
                      <td>{m.name}</td>
                      <td>{m.dose || '—'}</td>
                      <td>{m.frequency || '—'}</td>
                      <td>{m.days || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {prescription.general_advice && (
              <>
                <h6 className="fw-bold">Advice</h6>
                <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
                  {prescription.general_advice}
                </p>
              </>
            )}

            {/* ── Doctor Digital Signature ── */}
            {signatureUrl && (
              <div
                className="mt-4 pt-3 d-flex flex-column align-items-end"
                style={{ borderTop: '1px solid #dee2e6' }}
              >
                <div
                  className="border rounded-3 d-flex align-items-center justify-content-center mb-1"
                  style={{
                    width: 200,
                    height: 80,
                    background: '#fff',
                    overflow: 'hidden',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                  }}
                >
                  <img
                    src={signatureUrl}
                    alt="Doctor digital signature"
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </div>
                <p className="mb-0 fw-semibold small"> {prescription.doctor_name}</p>
                <p className="mb-0 text-muted" style={{ fontSize: '0.72rem' }}>
                  <i className="bi bi-shield-check me-1 text-success" />
                  Digital Signature
                </p>
              </div>
            )}
          </div>
          <div className="modal-footer border-0 d-flex flex-wrap gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary rounded-pill" onClick={handleDownload}>
              <i className="bi bi-download me-1" />
              Download
            </button>
            <button type="button" className="btn btn-outline-primary rounded-pill" onClick={handlePrint}>
              <i className="bi bi-printer me-1" />
              Print
            </button>
            <button type="button" className="btn btn-primary rounded-pill" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewPrescriptionModal;
